<!-- 🔴 FRANJA ROJA — siempre visible -->
<nav class="navbar navbar-expand barra-gobmx px-4">

  <a class="navbar-brand" href="https://www.gob.mx/" target="_blank">
    <img
      src="https://framework-gb.cdn.gob.mx/landing/img/logoheader.svg"
      class="logo-gobierno"
      alt="Gobierno de México">
  </a>

  <div class="collapse navbar-collapse justify-content-end">
    <ul class="navbar-nav d-flex align-items-center gap-4 text-white">
      <li class="nav-item">
        <a href="https://www.gob.mx/" class="nav-link text-white">
          Trámites
        </a>
      </li>

      <li class="nav-item">
        <a href="https://www.gob.mx/" class="nav-link text-white">
          Gobierno
        </a>
      </li>

      <li class="nav-item">
        <a href="https://www.gob.mx/busqueda" class="nav-link text-white">
          <i class="bi bi-search"></i>
        </a>
      </li>
    </ul>
  </div>

</nav>

<!-- ⚪ FRANJA BLANCA — se oculta al hacer scroll -->
<div
  class="franja-blanca"
  [class.ocultar-franja-blanca]="!mostrarHeader">

  <div class="contenedorGobierno py-3 px-4">

    <div class="d-flex justify-content-between align-items-center flex-wrap">

      <!-- LOGOS -->
      <div class="d-flex align-items-center gap-3">

        <a href="https://www.gob.mx/sep" target="_blank" rel="noopener noreferrer">
          <img src="assets/logos/educacion.png" class="logo-educacion" alt="SEP">
        </a>

        <img src="assets/logos/tecnm.jpg" class="logo-tecnm">

        <img src="assets/encabezado/ESCUDO_GRIS.png" class="logo-escudo">

        <img src="assets/encabezado/logo_seduc.png" class="logo-seduc">

        <a href="https://escarcega.tecnm.mx/#/Inicio" target="_blank" rel="noopener noreferrer">
          <img src="assets/encabezado/logo.png" class="logo-itse" alt="ITSE">
        </a>

      </div>

      <!-- HERRAMIENTAS -->
      <div class="top-tools">

        <div class="header-logos">

          <div class="tools-right">

            <!-- CORREO -->
            <img
              class="tool-icon"
              src="assets/encabezado/correo-icono.png"
              alt="Correo"
              (click)="abrirCorreo()">

            <!-- CALENDARIO -->
            <img
              class="tool-icon"
              src="assets/encabezado/calendario-icono.png"
              alt="Calendario"
              (click)="abrirCalendario()">

            <!-- CHINO -->
            <img
              class="tool-icon"
              [class.activo]="idiomaActual === 'zh'"
              src="assets/encabezado/china-icono.png"
              (click)="cambiarIdioma('zh')">

            <!-- INGLÉS -->
            <img
              class="tool-icon"
              [class.activo]="idiomaActual === 'en'"
              src="assets/encabezado/usa-icono.png"
              (click)="cambiarIdioma('en')">

            <!-- ESPAÑOL -->
            <img
              class="tool-icon"
              [class.activo]="idiomaActual === 'es'"
              src="assets/encabezado/mexico-icono.png"
              (click)="cambiarIdioma('es')">

            <!-- FUENTE -->
            <button
              class="font-btn"
              (click)="disminuirFuente()">
              A-
            </button>

            <button
              class="font-btn"
              (click)="normalFuente()">
              A
            </button>

            <button
              class="font-btn"
              (click)="aumentarFuente()">
              A+
            </button>

          </div>

        </div>

      </div>

    </div>

  </div>

</div>

<!-- 🔵 FRANJA AZUL (menú) — siempre visible, sticky bajo la roja -->
<nav class="navbar navbar-expand-lg navbar-dark menu-bar">

  <div class="container-fluid">

    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#menuNav"
      aria-controls="menuNav" aria-expanded="false" aria-label="Abrir menú de navegación">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="menuNav" (click)="onMenuNavClick($event)">

      <ul class="navbar-nav">

        <!-- Logo TecNM (visible al hacer scroll) -->
        <li class="nav-item d-flex align-items-center">
          <img
            class="logo-tecnm-nav"
            [class.logo-tecnm-nav--visible]="!mostrarHeader"
            src="assets/encabezado/LogoTecNM_Blanco.png"
            alt="Tecnológico Nacional de México">
        </li>

        <!-- Home -->
        <li class="nav-item">
          <a class="nav-link text-white" routerLink="/Inicio">
            <i  class="bi bi-house-fill"></i>
          </a>
        </li>

        <!-- Nivel 1 -->
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle text-white" data-bs-toggle="dropdown">
            Programas Educativos
          </a>

          <ul class="dropdown-menu">

            <!-- Submenu -->
            <li class="dropdown-submenu">
              <a routerLink="/programas-educativos/ing-ia" class="dropdown-item">Ingenieria en inteligencia artificial</a>
            </li>
            <li>
              <a  routerLink="/programas-educativos/ing-sc-virtual"  class="dropdown-item">Ingenieria en sistemas computacionales Virtual </a>
            </li>
            <li>
              <a routerLink="/programas-educativos/ing-animacion" class="dropdown-item">Ingenieria en Animación Digital y Efectos Visuales</a>
            </li>
            <li>
              <a  routerLink="/programas-educativos/ing-energias-renovables"    class="dropdown-item">Ingenieria en Energias Renovables</a>
            </li>
            <li>
              <a   routerLink="/programas-educativos/ing-ferro"   class="dropdown-item">Ingenieria Ferroviaria</a>
            </li>
            <li>
              <a  routerLink="/programas-educativos/ing-industrias-alianza"    class="dropdown-item">Ingenieria en Industrias Alimentarias</a>
            </li>
            <li>
              <a routerLink="/programas-educativos/ing-isc"  class="dropdown-item">Ingenieria en Sistemas Computacionales </a>
            </li>
            <li>
              <a  routerLink="/programas-educativos/lic-admin-mixta"   class="dropdown-item">Licenciatura en Administracion Modalidad Mixta</a>
            </li>
            <li>
              <a routerLink="/programas-educativos/lic-admin"  class="dropdown-item">Licenciatura en Administracion</a>
            </li>
            <li>
              <a   routerLink="/programas-educativos/lic-gastro"  class="dropdown-item">Licenciatura en Gastronomia</a>
            </li>
            <li>
              <a  routerLink="/programas-educativos/lic-turismo" class="dropdown-item">Licenciatura en Turismo</a>
            </li>
            <li>
              <a  routerLink="/programas-educativos/contador-publico"   class="dropdown-item">Contador Publico</a>
            </li>
          
          </ul>
        </li>

          <!-- Lista de Menu de ITSESCARCEGA -->
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle text-white" data-bs-toggle="dropdown">
            Posgrados
          </a>
          <ul class="dropdown-menu">
            <li>
              <a  href="https://escarcega.tecnm.mx/maestria/"  class="dropdown-item">Maestria en Economia Social y Solidaria</a>
            </li>
 <!--            <li>
              <a routerLink="/https://itsedirectorio.streamlit.app/?Directorio_Itse=1"  class="dropdown-item">Directorio</a>
            </li>
            <li>
              <a  routerLink="/ITSESCARCEGA/normativa"   class="dropdown-item">Normatividad</a>
            </li>
            <li>
              <a  routerLink="/ITSESCARCEGA/manual-line"   class="dropdown-item">Manual de Lineamientos TecNM</a>
            </li>
            <li>
              <a  routerLink="/ITSESCARCEGA/convocatoria"   class="dropdown-item">Convocatorias</a>
            </li> -->



          </ul>
        </li>


        <!-- Lista de Menu de ITSESCARCEGA -->
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle text-white" data-bs-toggle="dropdown">
            ITSESCARCEGA
          </a>
          <ul class="dropdown-menu">
            <li>
              <a  routerLink="/ITSESCARCEGA/historia"  class="dropdown-item">Historia</a>
            </li>
            <li>
              <a routerLink="/ITSESCARCEGA/directorio"  class="dropdown-item">Directorio</a>
            </li>
            <li>
              <a  routerLink="/ITSESCARCEGA/normativa"   class="dropdown-item">Normatividad</a>
            </li>
            <li>
              <a  routerLink="/assets/home_logos/Manual_de_Lineamientos_TecNM.pdf"   class="dropdown-item">Manual de Lineamientos TecNM</a>
            </li>
            <li>
              <a  routerLink="/ITSESCARCEGA/convocatoria"   class="dropdown-item">Convocatorias</a>
            </li>



          </ul>
        </li>

        <!-- menu plataforma -->
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle text-white" data-bs-toggle="dropdown">
            Plataformas
          </a>
          <ul class="dropdown-menu">

            <li>
              <a  href="https://acad.itsescarcega.edu.mx/login/index.php"  class="dropdown-item">Moodle</a>
            </li>
            <li>
              <a href="https://app.itsescarcega.edu.mx/" class="dropdown-item">SITSE</a>
            </li>
            <li>
              <a  routerLink="/Plataforma/siaceb" class="dropdown-item">Siaceb</a>
            </li>
            <li>
              <a  routerLink="/Plataforma/tutorias" class="dropdown-item">Tutorias</a>
            </li>
            <li>
              <a   href="https://ti.itsescarcega.edu.mx/mantenimiento-app/#/login" class="dropdown-item">Sistema de Mantenimiento</a>
            </li>
            <li>
              <a href="http://187.157.86.214/sed/" target="_blank" rel="noopener noreferrer" class="dropdown-item">Evaluacion Docente</a>
            </li>
            <li>
              <a  href="https://tecnmmx.digitaliapublishing.com/"  class="dropdown-item">Registro Biblioteca</a>
            </li>
            <li>
              <a  href="https://elibro.net/es/lc/itsescarcega/login_usuario/" class="dropdown-item">Elibro ITSE</a>
            </li>
            <li>
              <a  href="https://itsecertificado.netlify.app/" class="dropdown-item">Certificados</a>
            </li>



          </ul>
        </li>


        <!-- menu servicios  -->
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle text-white" data-bs-toggle="dropdown">
            Servicios
          </a>
          <ul class="dropdown-menu">

            <li>
              <a  routerLink="/Servicios/centro-computo" class="dropdown-item">Centro de Cómputo</a>
            </li>
            <li>
              <a routerLink="/Servicios/recursos-financieros" class="dropdown-item">Recursos Financieros</a>
            </li>
            <li>
              <a routerLink="/Servicios/centro-informacion" class="dropdown-item">Centro de Información</a>
            </li>
            <li>
              <a routerLink="/Servicios/administracion-escolar" class="dropdown-item">Administración Escolar</a>
            </li>
            <li>
              <a  class="dropdown-item"  href="https://ti.itsescarcega.edu.mx/encuesta-app/#/login" target="_blank">Encuesta de Servicio</a>
            </li>
            <li>
              <a   href="/assets/servicios/lactario.pdf"  class="dropdown-item">Lactario</a>
            </li>
          
            <li>
              <a href="https://escarcega.tecnm.mx/constancias_congreso2026/"
                    class="dropdown-item"
                    target="_blank"
                    rel="noopener noreferrer">
                      Constancias Congreso Turístico Gastronómico 2026
                  </a>
            </li>

            
          </ul>
        </li>


        
          <!-- Lista de Menu de CONGRESOS -->
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle text-white" data-bs-toggle="dropdown">
            Congresos
          </a>
          <ul class="dropdown-menu">
            <li>
              <a href="https://escarcega.tecnm.mx/congreso/"
                    class="dropdown-item"
                    target="_blank"
                    rel="noopener noreferrer">
                      Congreso Turístico y Gastronómico
                  </a>
            </li>
            <li>
              <a  href="https://cicagde.org/" class="dropdown-item">Congreso Internacional de las Ciencias Económico-Administrativas </a>
            </li>
 
          </ul>
        </li>

        <!-- menu sistema gestion -->
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle text-white" data-bs-toggle="dropdown">
            Sistemas de gestión
          </a>
          <ul class="dropdown-menu">

            <li>
              <a   routerLink="/sistema-gestion/sistema-ges-igualdad" class="dropdown-item">Sistema de Gestion de Igualdad de Genero y no Discriminacion</a>
            </li>
            <li>
              <a   routerLink="/sistema-gestion/sistema-ges-integral"   class="dropdown-item">Sistema de Gestion Integral (SGI) </a>
            </li>
            <li>
              <a  routerLink="/sistema-gestion/proteccion-civil"  class="dropdown-item">Proteccion Civil y Accesibilidad</a>
            </li>
            <li>
              <a     routerLink="/sistema-gestion/quejas-denuncias" class="dropdown-item">Quejas y Denuncias</a>
            </li>
            <li>
              <a  routerLink="/itsebuzondiigital.000webhostapp.com" class="dropdown-item">Buzon Digital ITSE</a>
            </li>
            <li>
              <a   href="/assets/img_plataformas/Wallpaper_ITSE.jpg"  class="dropdown-item">Fondo de Pantalla Institucional</a>
            </li>
            <li>
              <a   href="/assets/img_plataformas/DIRECTORIO_ENLACES_DE_CJM-UNIVERSIDADES.xlsx" class="dropdown-item" target="_blank">Directorio Enlaces de CJM-Universidades </a>
            </li>

          </ul>
        </li>

<!-- menu gestion institucional -->
<li class="nav-item dropdown">
  <a class="nav-link dropdown-toggle text-white" data-bs-toggle="dropdown">
    Gestión Institucional
  </a>

  <ul class="dropdown-menu menu-programas">

    <!-- Misceláneos -->
    <li class="dropdown-submenu">
      <a class="dropdown-item dropdown-toggle">Misceláneos</a>

      <ul class="dropdown-menu submenu-programas">
        <li class="submenu-item">
          <a routerLink="/gestion_institucional/archivo" target="_blank" class="w-100 d-block text-dark text-decoration-none">Archivo</a>
        </li>
        <li class="submenu-item">
          <a routerLink="/gestion_institucional/contabilidad-institucional" target="_blank" class="w-100 d-block text-dark text-decoration-none">Contabilidad Institucional</a>
        </li>

        <li class="submenu-item">
          <a routerLink="/gestion_institucional/contralorias_sociales" target="_blank" class="w-100 d-block text-dark text-decoration-none">Contralorias Sociales</a>
        </li>

         <li class="submenu-item">
          <a routerLink="/gestion_institucional/comite-etica" target="_blank" class="w-100 d-block text-dark text-decoration-none">Comite De Etica</a>
        </li>
    
        <li class="submenu-item">
          <a routerLink="/gestion_institucional/accesibilidad" target="_blank" class="w-100 d-block text-dark text-decoration-none">Accesibilidad</a>
        </li>
      </ul>




    </li>

    <!-- Vinculación -->
    <li>
      <a class="dropdown-item" routerLink="/gestion_institucional/vinculacion" target="_blank">Vinculación</a>
    </li>

    <!-- Transparencia -->
    <li class="dropdown-submenu">
      <a class="dropdown-item dropdown-toggle">Transparencia</a>

      <ul class="dropdown-menu submenu-programas">
         <li class="submenu-item">
          <a routerLink="/gestion_institucional/indicadores-cia" target="_blank" class="w-100 d-block text-dark text-decoration-none">Vinculacion Indicadores CIA</a>
        </li>
        <li class="submenu-item">
          <a href="https://www.plataformadetransparencia.org.mx/Inicio" target="_blank" class="w-100 d-block text-dark text-decoration-none">Plataforma Nacional De Transparencia</a>
        </li>
        <li class="submenu-item">
          <a routerLink="/gestion_institucional/trasparencia-institucional" target="_blank" class="w-100 d-block text-dark text-decoration-none">Transparencia Institucional</a>
        </li>
        <li class="submenu-item">
          <a routerLink="/gestion_institucional/aviso-privacidad" target="_blank" class="w-100 d-block text-dark text-decoration-none">Aviso de privacidad</a>
        </li>
        <li class="submenu-item">
          <a routerLink="/gestion_institucional/index-trasparencia" target="_blank" class="w-100 d-block text-dark text-decoration-none">Index de Transparencia</a>
        </li>
         <li class="submenu-item">
          <a routerLink="/gestion_institucional/informes-trasparencia" target="_blank" class="w-100 d-block text-dark text-decoration-none">Informes de Transparencia</a>
        </li>
         <li class="submenu-item">
          <a routerLink="/gestion_institucional/ciie" target="_blank" class="w-100 d-block text-dark text-decoration-none">CIIE</a>
        </li>
      </ul>
    </li>

    <!-- Planeación -->
    <li class="dropdown-submenu">
      <a routerLink="/gestion_institucional/planeacion" target="_blank" class="dropdown-item dropdown-toggle">Planeación</a>

<!--       <ul class="dropdown-menu submenu-programas">
        <li class="submenu-item">
          <a routerLink="/https://google.com" target="_blank" class="w-100 d-block text-dark text-decoration-none">Plan Institucional</a>
        </li>
        <li class="submenu-item">
          <a routerLink="/https://google.com" target="_blank" class="w-100 d-block text-dark text-decoration-none">Objetivos Estratégicos</a>
        </li>
        <li class="submenu-item">
          <a routerLink="/https://google.com" target="_blank" class="w-100 d-block text-dark text-decoration-none">Indicadores</a>
        </li>
      </ul> -->
    </li>

    <!-- Contacto -->
    <li>
      <a class="dropdown-item" routerLink="/gestion_institucional/contactenos" target="_blank">Contáctenos</a>
    </li>

    <li>
      <a class="dropdown-item" routerLink="/gestion_institucional/rendicion-cuentas" target="_blank">Rendicion de Cuentas (IERC) </a>
    </li>

  </ul>
</li>

      </ul>

    </div>
  </div>
</nav>